import { ReactElement } from 'react'
import { ApplicationDetailsIndex } from 'src/screens/shared/application/details/ApplicationDetailsIndex'

export const PfPgvApplicationDetailsIndexPage = (): ReactElement => {
  return <ApplicationDetailsIndex baseUrl="/pf-pgv" />
}
